/* eslint-disable max-len */
import React from 'react';
import { withRouter, Switch, Route, Redirect, NavLink } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';

import * as actions from './actions';
import * as c from './constant';

// import BPLSNewTransactionOld from './new/container/TransactionContainer';
// import BPLSReNewTransactionOld from './renewal/container/TransactionContainer';

import BusinessTax from './businessTax/container/BusinessTaxContainer';
import TransactionContainer from './transactions/TransactionsContainer';
import SettingsContainer from './settings/SettingsContainer';

import ApplicationContainer from './applications/container/ApplicationContainer';
import TaxRevenuesContainer from './newTaxRevenues/TaxRevenuesContainer';
import BusinessContainer from './business/BusinessContainer';
import EBossContainer from './EBossContainer';
import BplsReportsContainer from './components/reports/containers/BplsReportsContainer';

function BPLSContainer({ match }) {
  const permissions = getJson('permissions');

  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">
          Business Permit and Licensing System
        </div>
        <SideScrollingTab dragToScroll hideScrollButtons>
          <div className="generic-module-nav">
            <NavLink
              exact
              className="nav-link"
              activeClassName="active"
              to="/bpls/transactions"
            >
              Dashboard
            </NavLink>
            {Acl(permissions, ['VIEW BPLS E-BOSS APPLICATION']) && (
              <NavLink
                exact={false}
                className="nav-link position-relative"
                activeClassName="active"
                to="/bpls/eboss-application"
              >
                E-Boss Application
              </NavLink>
            )}
            {Acl(permissions, ['VIEW BPLS APPLICATION']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/bpls/applications"
              >
                Applications
              </NavLink>
            )}
            {Acl(permissions, ['VIEW BPLS BUSINESSES']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/bpls/new-business"
              >
                Business
              </NavLink>
            )}
            {Acl(permissions, ['VIEW BPLS SETTING']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/bpls/settings"
              >
                Settings
              </NavLink>
            )}
            {Acl(permissions, ['VIEW BPLS TAX REVENUE']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/bpls/tax-revenue"
              >
                Tax Revenue
              </NavLink>
            )}
            {Acl(permissions, ['VIEW BPLS E2E REPORT']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/bpls/reports"
              >
                Reports
              </NavLink>
            )}

            {/* <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/bpls/bpls-new"
            >
              Temporary
            </NavLink> */}
          </div>
        </SideScrollingTab>
        <Switch>
          {Acl(permissions, ['VIEW BPLS DASHBOARD']) && (
            <Route
              path={`${match.path}/transactions`}
              component={TransactionContainer}
            />
          )}
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          {Acl(permissions, ['VIEW BPLS SETTING']) && (
            <Route
              path={`${match.path}/settings`}
              component={SettingsContainer}
            />
          )}
          {Acl(permissions, ['VIEW BPLS E-BOSS APPLICATION']) && (
            <Route
              path={`${match.path}/eboss-application`}
              component={EBossContainer}
            />
          )}

          {Acl(permissions, ['VIEW BPLS BUSINESSES']) && (
            <Route
              path={`${match.path}/new-business`}
              component={BusinessContainer}
            />
          )}
          {Acl(permissions, ['VIEW BPLS APPLICATION']) && (
            <Route
              path={`${match.path}/applications`}
              component={ApplicationContainer}
            />
          )}
          {Acl(permissions, ['VIEW BPLS TAX REVENUE']) && (
            <Route
              path={`${match.path}/tax-revenue`}
              component={TaxRevenuesContainer}
            />
          )}
          <Route path={`${match.path}/business-tax`} component={BusinessTax} />
          {Acl(permissions, ['VIEW BPLS E2E REPORT']) && (
            <Route
              path={`${match.path}/reports`}
              component={BplsReportsContainer}
            />
          )}

          {/* this is the original for computation */}
          {/* <Route
            path={`${match.path}/bpls-new`}
            component={BPLSNewTransactionOld}
          />
          <Route
            path={`${match.path}/bpls-renewal`}
            component={BPLSReNewTransactionOld}
          /> */}
          {/* end */}
        </Switch>
      </div>
    </>
  );
}

BPLSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BPLSContainer);
